import { Button } from '@cokitchen/cokitchen-components';
import LocalModal from 'components/base/local-modal';
import LocalTextArea from 'components/base/local-text-area';
import React, { useState } from 'react';

const DeliveryNotificationModal = ({
  show,
  onClose,
  setValue
}: {
  show: boolean;
  onClose: () => void;
  setValue?: (arg0: string) => void;
}) => {
  const [note, setNote] = useState('');
  return (
    <LocalModal
      isOpen={show}
      title='Delivery Instruction'
      description={``}
      titleIconColor='danger'
      onRequestClose={() => onClose()}
      footer={
        <div className='flex justify-end'>
          <Button
            className='w-[139px] h-[41px] text-sm'
            color='primary'
            small
            variant='block'
            onClick={() => {
              setValue?.(note);
              onClose();
            }}
            disabled={note === ''}>
            Confirm
          </Button>
        </div>
      }>
      <div>
        <LocalTextArea
          label='Add rider note'
          rows={4}
          placeholder='e.g call when you are at the estate gate'
          value={note}
          onChange={(e: any) => {
            setNote(e.target.value);
          }}
        />
      </div>
    </LocalModal>
  );
};

export default DeliveryNotificationModal;
